<template>
        <div>
            <v-menu min-width="250" offset-y offset-x>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn text v-bind="attrs" v-on="on" fab small class="ma-auto">
                        <v-icon>mdi-account-circle</v-icon>
                    </v-btn>
                </template>

                <v-card>
                    <v-list rounded class="py-6">
                        <v-list-item @click="open_password = true">
                            <v-list-item-icon>
                                <v-icon>mdi-account</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>Cuenta</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-if="userAtLeastIs(user, LEVEL_ADMIN)" @click="$router.push({ name: 'Configuration' })">
                            <v-list-item-icon>
                                <v-icon>mdi-cog</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>Configuraciones</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item @click="doLogout">
                            <v-list-item-icon>
                                <v-icon>mdi-power</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>Cerrar sesión</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card>
            </v-menu>
            <formPassword :open="open_password" @close="open_password = false"/>
        </div>
</template>

<script>
import { LEVEL_ADMIN, userAtLeastIs } from '../../plugins/checkPermission'
import formPassword from '../formPassword'
import { mapState, mapActions } from 'vuex'

export default {
    name: 'user-menu',
    components: { formPassword },
    computed: {
        ...mapState({ user: state => state.user.profile.level })
    },
    data() {
        return {
            LEVEL_ADMIN,
            open_password: false
        }
    },
    methods:{
        ...mapActions( { logout: 'user/logout' } ),
        userAtLeastIs,
        async doLogout(){
            try {
                await this.logout()
                this.$router.push({ name: 'Login' })
            } catch (error) {
                console.log(error)
            }
        }
    }
}
</script>